module.exports = __webpack_public_path__ + "img/img18.cb6958e2.png";